import { ActionType, createAsyncAction } from 'typesafe-actions';

import { OfflinePeriodCreationError } from 'rdx/offlinePeriods/OfflinePeriodCreationError';

import {
  CreateProviderOfflinePeriodRequest,
  CreateProviderOfflinePeriodResponse,
  GetProviderOfflinePeriodsResponse,
} from '../../../../common/all/api/gen/DeliveryProviderPortalAuthApi';

export const getOfflinePeriodsAsyncAction = createAsyncAction(
  '@offlinePeriods/GET_OFFLINE_PERIODS_START',
  '@offlinePeriods/GET_OFFLINE_PERIODS_SUCCESS',
  '@offlinePeriods/GET_OFFLINE_PERIODS_FAILURE',
)<void, GetProviderOfflinePeriodsResponse, Error>();

export const createOfflinePeriodAsyncAction = createAsyncAction(
  '@offlinePeriods/CREATE_OFFLINE_PERIOD_START',
  '@offlinePeriods/CREATE_OFFLINE_PERIOD_SUCCESS',
  '@offlinePeriods/CREATE_OFFLINE_PERIOD_FAILURE',
)<
  CreateProviderOfflinePeriodRequest,
  CreateProviderOfflinePeriodResponse,
  OfflinePeriodCreationError
>();

export const cancelOfflinePeriodAsyncAction = createAsyncAction(
  '@offlinePeriods/CANCEL_OFFLINE_PERIOD_START',
  '@offlinePeriods/CANCEL_OFFLINE_PERIOD_SUCCESS',
  '@offlinePeriods/CANCEL_OFFLINE_PERIOD_FAILURE',
)<{ provider_id: number; offline_period_id: number }, void, Error>();

export type OfflinePeriodsActions =
  | ActionType<typeof getOfflinePeriodsAsyncAction>
  | ActionType<typeof createOfflinePeriodAsyncAction>
  | ActionType<typeof cancelOfflinePeriodAsyncAction>;
